import { CascadiaTheme, ThemeContext } from "@certn/cascadia";
import { usePeopleAPI } from "@certn/legacy-api";
import { useContext, useEffect } from "react";

import { useAuth } from "../../pages/auth/hooks";

export function useUser() {
  const { logout } = useAuth();
  const {
    data: user,
    isLoading,
    mutate,
  } = usePeopleAPI("/internal/people/me/", undefined, {
    onError: (err) => err?.status === 401 && logout(),
  });
  const { setTheme } = useContext(ThemeContext);
  const theme: CascadiaTheme = user?.personal_profile?.profile_preferences
    ?.dark_mode_enabled
    ? "dark"
    : "light";

  useEffect(() => {
    if (user) {
      setTheme(theme);
    }
  }, [user]);

  return {
    user,
    isLoading,
    mutate,
  };
}
